import { Trophy } from 'lucide-react'

export default function StandingsDriverPosCell({ position }) {
  const data = {
    icon: null,
    color: '',
    bgColor: 'bg-neutral-blue-800!',
    borderColor: 'border-neutral-blue-800!',
  }

  switch (position) {
    case 1:
      data.color = 'medals-gold'
      data.bgColor = 'bg-[#FF99004D]!'
      data.borderColor = 'border-medals-gold!'
      break
    case 2:
      data.color = 'medals-silver'
      data.bgColor = 'bg-[#F2F2F24D]!'
      data.borderColor = 'border-medals-silver!'
      break
    case 3:
      data.color = 'medals-bronze'
      data.bgColor = 'bg-[#FF72224D]!'
      data.borderColor = 'border-medals-bronze!'
      break
  }

  if (position < 4) {
    data.icon = <Trophy className={`-mt-1 md:size-8 stroke-${data.color}`} />
  } else {
    const suffix = ['th', 'st', 'nd', 'rd']
    const modulo = position % 100
    const positionSuffix =
      modulo >= 11 && modulo <= 13
        ? suffix[0]
        : suffix[position % 10 > 3 ? 0 : position % 10]

    data.icon = `${position}${positionSuffix}`
  }

  return (
    <div
      className={`grid h-full min-h-[42px] w-[42px] items-center justify-center rounded-sm border text-sm font-medium tabular-nums md:min-h-[68px] md:w-[68px] md:text-h-6-sm ${data.borderColor} ${data.bgColor}`}
    >
      {data.icon}
    </div>
  )
}
